module.exports = __webpack_public_path__ + "img/pagination-CO2.0af0bc3d.svg";